const metadataCache = {}

export default {
  methods: {
    getAspect (image) {
      let meta
      if (metadataCache[image.metaData]) {
        meta = metadataCache[image.metaData]
      } else {
        meta = metadataCache[image.metaData] = JSON.parse(image.metaData)
      }
      return meta['image-width'] / meta['image-height']
    }
  }
}
